var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"gl-shrink-0",attrs:{"icon":"lock","title":_vm.title,"aria-label":_vm.title,"variant":"warning","data-testid":"locked-badge"}})
}
var staticRenderFns = []

export { render, staticRenderFns }